import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { font } from '../styles/typography';
import { getOutdatedVersion, subscribeOutdated, reloadForNewVersion } from '../utils/appVersionGuard';

const Bar = styled.div`
  position: fixed;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  z-index: 3000;
  display: flex;
  align-items: center;
  gap: 12px;
  max-width: calc(100vw - 32px);
  padding: 10px 14px;
  border-radius: 8px;
  background: var(--spark-color-warning-surface);
  color: var(--spark-color-warning-text);
  border: 1px solid var(--spark-color-warning-text);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  ${font('md')}
  button {
    font: inherit;
    font-weight: 600;
    cursor: pointer;
    padding: 4px 12px;
    border-radius: 6px;
    border: 1px solid var(--spark-color-warning-text);
    background: transparent;
    color: inherit;
  }
`;

/**
 * Фронт застарів (бекенд відповів новішою X-App-Version). Оновлюємо автоматично:
 * при наступному переході між сторінками (форма в цей момент уже закрита) або коли вкладка у фоні;
 * плашка з кнопкою — на випадок, якщо користувач хоче оновитись одразу.
 */
export default function AppUpdateWatcher() {
  const [version, setVersion] = useState(getOutdatedVersion());
  const location = useLocation();
  const first = useRef(true);

  useEffect(() => subscribeOutdated(setVersion), []);

  useEffect(() => {
    if (first.current) { first.current = false; return; }
    if (version) reloadForNewVersion();
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!version) return null;
  return (
    <Bar role="status">
      <span>Доступна нова версія {version}. Сторінка оновиться при переході до іншого розділу.</span>
      <button type="button" onClick={() => reloadForNewVersion()}>Оновити зараз</button>
    </Bar>
  );
}
